import { IBidResponse } from '../../typings/IPrebid'
import { Bidder } from '../enums'
/* eslint-disable */
/* 
  This function must be 100% pure, meaning no external dependencies can be
  referenced. All dependencies must be injected as arguments.
 */
export function renderAdSafeframe(adObject: IBidResponse) {
  var body = window.document.body
  var ad = adObject.ad
  var url = adObject.adUrl
  var width = adObject.width
  var height = adObject.height
  if (adObject.mediaType === 'video') {
    console.log('Error trying to write ad.')
  } else if (ad) {
    var frame = document.createElement('iframe')
    frame.setAttribute('FRAMEBORDER', '0')
    frame.setAttribute('SCROLLING', 'no')
    frame.setAttribute('MARGINHEIGHT', '0')
    frame.setAttribute('MARGINWIDTH', '0')
    frame.setAttribute('TOPMARGIN', '0')
    frame.setAttribute('LEFTMARGIN', '0')
    frame.setAttribute('ALLOWTRANSPARENCY', 'true')
    frame.setAttribute('width', width.toString())
    frame.setAttribute('height', height.toString())
    body.appendChild(frame)
    if (frame.contentDocument) {
      frame.contentDocument.open()
      frame.contentDocument.write(ad)
      frame.contentDocument.close()
    }
  } else if (url) {
    body.insertAdjacentHTML(
      'beforeend',
      '<IFRAME SRC="' +
        url +
        '" FRAMEBORDER="0" SCROLLING="no" MARGINHEIGHT="0" MARGINWIDTH="0" TOPMARGIN="0" LEFTMARGIN="0" ALLOWTRANSPARENCY="true" WIDTH="' +
        width +
        '" HEIGHT="' +
        height +
        '"></IFRAME>'
    )
  }
}

export function renderAdNonSafeframe(adObject: IBidResponse) {
  var w: any = window
  for (var i = 0; i < 10; i++) {
    w = w.parent
    if (w.pbjs) {
      try {
        // @ts-ignore
        w.pbjs.renderAd(document, adObject.adId)
        break
      } catch (e) {
        continue
      }
    }
  }
}
